import { Katelogosmall1a } from './Images.js';
import LazyImage from './components/LazyImage';

import './css/App.css';
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

function HeaderMenu() {
    const isMobile = useMediaQuery({ query: `(max-width: 960px)` });
    return (
      <div className="headermainbody"> 
        <div className="headerbanner">
            <div className="header-logo-div">
                <Link to={`/`}>
                    <LazyImage 
                        className={isMobile ? "header-logo-img-mobile" : "header-logo-img"} 
                        src={Katelogosmall1a} 
                        alt="Kate the Chemist Logo"
                    />
                </Link>
            </div>
            <div className={isMobile ? "header-banner-menu-items-mobile" : "header-banner-menu-items"}>
                <div className="banner-section-title">
                    <Link to={`/livetv`} className="hyperlink">Live TV</Link>
                </div> 
                <div className="banner-section-title">
                    <Link to={`/podcasts`} className="hyperlink">Podcast</Link>
                </div> 
                <div className="banner-section-title">
                    <Link to={`/books`} className="hyperlink">Books</Link>
                </div> 
                <div className="banner-section-title">
                    <Link to={`/articles`} className="hyperlink">Articles</Link>
                </div> 
                <div className="banner-section-title">
                    <Link to={`/about`} className="hyperlink">About</Link>
                </div> 
                <div className="banner-section-title">
                    <Link to={`/contact`} className="hyperlink">Contact</Link>
                </div> 
            </div>
        </div>
      </div>


  );
}

export default HeaderMenu;
